// libs/error-handling/src/lib/errors/ExternalAPIError.ts
import { BaseError } from './BaseError.js';
export class ExternalAPIError extends BaseError {
    endpoint;
    responseData;
    requestParams;
    retryable;
    /**
     * Custom error class for handling errors related to external API requests.
     * @param message - Description of the external API error.
     * @param statusCode - HTTP status code returned by the external API (default: 500).
     * @param endpoint - URL of the external API endpoint.
     * @param responseData - Optional response data returned by the external API.
     * @param requestParams - Optional parameters or payload sent in the API request.
     * @param retryable - Flag indicating if the error is retryable (default: false).
     */
    constructor(message, endpoint, responseData, requestParams, retryable = false, statusCode = 500) {
        super(message, statusCode);
        this.endpoint = endpoint;
        this.responseData = responseData;
        this.requestParams = requestParams;
        this.retryable = retryable;
    }
}
//# sourceMappingURL=ExternalAPIError.js.map